/**
 * DashboardStatisticsTrendReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * DashboardStatisticsTrendReq
 */
export interface DashboardStatisticsTrendReq {
  /** 页码（默认第1页） */
  page?: number
  /** 每页天数（默认7天） */
  page_size?: number
}

/**
 * DashboardStatisticsTrendReq Schema
 */
export const DashboardStatisticsTrendReqSchema: SchemaDefinition = {
  properties: {
    page: {
      default: 1,
      description: '页码（默认第1页）',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      default: 7,
      description: '每页天数（默认7天）',
      format: 'int',
      type: 'integer',
      label: '每页天数',
    },
  },
  type: 'object',
}
